const baseURL = process.env.VUE_APP_API_BASE_URL;

export { baseURL as default };
